import React, { useState, useEffect, useRef } from 'react';
import { Play, Pause, ChevronRight, RotateCcw, Home, Volume2 } from 'lucide-react';
import { API_BASE_URL } from '../config';

const SensoryGame = ({ config, onEnd }) => {
    const [items, setItems] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const audioRef = useRef(null);

    useEffect(() => {
        if (config && config.items) {
            const shuffled = [...config.items].sort(() => 0.5 - Math.random());
            setItems(shuffled);
        }
    }, [config]);

    useEffect(() => {
        setIsPlaying(false);
        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.load();
            audioRef.current.currentTime = 0;
        }
    }, [currentIndex]);

    const toggleAudio = () => {
        if (audioRef.current) {
            if (isPlaying) {
                audioRef.current.pause();
            } else {
                audioRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    if (items.length === 0) return <div className="game-loading">Chargement...</div>;

    const item = items[currentIndex];
    const isFinished = currentIndex >= Math.min(items.length, 10);

    if (isFinished) {
        return (
            <div className="sensory-end-card">
                <h2 className="end-title">Séance terminée</h2>
                <p className="end-subtitle">Nous espérons que ce moment vous a plu.</p>
                <div className="end-actions">
                    <button onClick={() => window.location.reload()} className="btn-replay">
                        <RotateCcw /> Relancer
                    </button>
                    <button onClick={() => onEnd(0)} className="btn-home">
                        <Home /> Accueil
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="sensory-container">
            <div className="sensory-header-info">
                <span className="game-title-label">{config.title}</span>
                <span className="game-counter">{currentIndex + 1} / {Math.min(items.length, 10)}</span>
            </div>

            <div className="sensory-media-frame">
                <img
                    src={item.image?.startsWith('http') ? item.image : `${API_BASE_URL}${item.image}`}
                    alt={item.title}
                    className={`sensory-image ${isPlaying ? 'active' : 'dimmed'}`}
                />

                <div className="sensory-caption-overlay">
                    <h2 className="media-title">{item.title}</h2>
                    {item.artist && <p className="media-artist">{item.artist}</p>}
                </div>
            </div>

            {item.audio && (
                <div className="sensory-audio-player">
                    <button onClick={toggleAudio} className="btn-audio-toggle">
                        {isPlaying ? <Pause size={30} /> : <Play size={30} className="icon-play-fix" />}
                    </button>
                    <div className="audio-info">
                        <div className="audio-label">Ambiance Sonore</div>
                        <div className="audio-sublabel">Cliquez pour {isPlaying ? 'mettre en pause' : 'écouter'}</div>
                    </div>
                    <Volume2 className="volume-icon" />
                    <audio
                        ref={audioRef}
                        src={item.audio?.startsWith('http') ? item.audio : `${API_BASE_URL}${item.audio}`}
                        loop={config.type === 'relaxation'}
                    />
                </div>
            )}

            <div className="sensory-script-box">
                <h3 className="script-header">
                    {config.type === 'relaxation' ? "📖 Script pour l'animateur" : "💬 Pour échanger"}
                </h3>
                <p className="script-content">
                    {item.script || item.question}
                </p>
            </div>

            <div className="sensory-navigation">
                <button onClick={() => setCurrentIndex(currentIndex + 1)} className="btn-next-sensory">
                    Suivant <ChevronRight />
                </button>
            </div>
        </div>
    );
};

export default SensoryGame;